import { datadogLogs } from '@datadog/browser-logs';
import React from 'react';
import MobileView from './MobileView/MobileView';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    console.log({ error, errorInfo });
    datadogLogs.logger.error(error, errorInfo, 'ErrorBoundary');
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError && this.state.error.name === 'SecurityError') {
      // You can render any custom fallback UI
      return (
        <MobileView>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              padding: '0 2.4rem',
              textAlign: 'center',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#000',
              backgroundColor: '#fff',
              lineHeight: '1.4',
            }}
          >
            {' '}
            <img
              src="/dead_page.png"
              alt="logo"
              style={{ width: '120px', height: 'auto' }}
            />
            <h3 style={{ margin: '1.2rem 0 0 0' }}>
              حدث خطأ ما، يرجى التواصل مع الدعم الفني
            </h3>
            <p>
              رمز الخطأ <span style={{ color: '#F00' }}>{10001}</span>
            </p>
          </div>
        </MobileView>
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default ErrorBoundary;
